import React from 'react';

export default class Val extends React.Component {

  // constructor(props) {
  //   super(props);
  //
  //   // this.state = {
  //   //   data : [],
  //   //   value: 'coconut',
  //   //   toDo: true,
  //   // };
  // }


  render() {
    return (

      <div className={this.props.strict?'readOnlyValue':''}>{this.props.val}</div>
    )
  }
}
